.containerWithHorizontalNav,
.container,
.dependencyReportMacroContainer {
	display: flex;
	gap: calc(var(--jpo-common-base-spacing));
	align-items: center;
}

.container {
	padding: 0 calc(3 * var(--jpo-common-base-spacing)) calc(2 * var(--jpo-common-base-spacing))
		calc(5 * var(--jpo-common-base-spacing));
}

.dependencyReportMacroContainer {
	padding: 0 calc(2 * var(--jpo-common-base-spacing)) calc(2 * var(--jpo-common-base-spacing))
		calc(2 * var(--jpo-common-base-spacing));
}

.containerWithHorizontalNav,
.container,
.spaContainer,
.dependencyReportMacroContainer {
	border-bottom: 1px solid var(--ds-border, var(--adg3-color-N50));
}

.addDependencyContainer {
	justify-content: flex-end;
	flex-grow: 1;
	display: flex;
}

.legendContainer {
	display: flex;
	justify-content: flex-end;
	flex: 1;
}

.containerWithHorizontalNav {
	padding: calc(2 * var(--jpo-common-base-spacing)) calc(3 * var(--jpo-common-base-spacing));
}
